import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=62d5be12&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports